import { useState, useEffect } from "react";
import axios from "axios";
import { BACKEND_URL } from "../config/config";

/**
 * Hook personnalisé pour récupérer et gérer les LaborUnion depuis l'API
 * Fournit les données dans différents formats selon les besoins des composants
 */
export const useLaborUnions = () => {
  const [laborUnions, setLaborUnions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLaborUnions = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BACKEND_URL}/api/laborUnion/list`, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        setLaborUnions(response.data);
        setError(null);
      } catch (err) {
        console.error("Erreur lors du chargement des laborUnion:", err);
        setError(err);
        // Fallback sur des valeurs par défaut en cas d'erreur
        setLaborUnions([
          { id: 4, label: "TP", active: true },
          { id: 3, label: "FFB", active: true },
          { id: 2, label: "CAPEB", active: true },
          { id: 1, label: "Aucun", active: true },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchLaborUnions();
  }, []);

  // Format pour les Select Ant Design : [{value, label}]
  const laborUnionsOptions = laborUnions
    .filter((lu) => lu.active)
    .map((lu) => ({
      value: lu.id,
      label: lu.label,
    }));

  // Format pour les Select custom : [{id, name}]
  const laborUnionsSelectOptions = laborUnions
    .filter((lu) => lu.active)
    .map((lu) => ({
      id: lu.id,
      name: lu.label,
    }));

  // Fonction helper pour obtenir le label d'un laborUnion par son ID
  const getLaborUnionLabel = (id) => {
    if (!id) return null;
    const laborUnion = laborUnions.find((lu) => lu.id === id);
    return laborUnion ? laborUnion.label : null;
  };

  return {
    laborUnions, // Données brutes : [{id, label, active}]
    laborUnionsOptions, // Format Ant Design : [{value, label}]
    laborUnionsSelectOptions, // Format custom : [{id, name}]
    getLaborUnionLabel, // Fonction helper
    loading,
    error,
  };
};
